// Const fonts = {
// PpNeueMachinaLight: "PP-Neue-Machina-Light",
// };

import ThemeInterface from "types/ThemeInterface";

const typography = (theme: ThemeInterface) => ({
  h1: {
    // FontFamily: `${fonts.ppNeueMachinaLight}`,
    fontSize: "3.6rem",
    lineHeight: "135%",
    letterSpacing: "0",
    fontWeight: "400",
    [theme.customTheme.breakpoints.up("lg")]: {
      fontSize: "6.0rem",
      lineHeight: "130%",
    },
  },
});

export default typography;
